import { FieldSchema } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";

// Grid/table-only field (not part of the equipment form). Reads as an enum
// semantically but the table uses a text filter, so pin it explicitly.
export const pressureEquipment: FieldSchema = {
  name: "pressureEquipment",
  // Read-only / additional-info field: fetched & displayed, but excluded from
  // create/update mutations (managed outside the schema equipment form).
  dataTransform: { toGraphql: undefined },
  grid: {
    displayed: true,
    order: 58,
    label: "Pressure equipment",
    filter: GridFilterTypes.TEXT,
    sortable: false,
    ignoredForSearch: true,
  },
};
